export interface FeaturesListResponse {
  cryptographyVersion: string;
  poaIsEnabled: string;
  adsIsEnabled: string;
  actsRegistryEnabled?: string;
  /** Весь флоу версионирования ОЖР: версии, заявки на изменение, OJR-панель */
  ojrFormationFlowEnabledV1?: string;
  /** Настройки интеграции в надзорном деле */
  supervisionIntegrationSettingsEnabled?: string;
  [key: string]: string | undefined;
}

export interface ParsableFeaturesFlags {
  cryptographyVersion: string;
  poaIsEnabled: boolean;
  adsIsEnabled: boolean;
  actsRegistryEnabled: boolean;
  ojrFormationFlowEnabledV1: boolean;
  supervisionIntegrationSettingsEnabled: boolean;
}

export type FlagKey = keyof ParsableFeaturesFlags;

export const parseFeaturesFlags = (
  raw: FeaturesListResponse,
): ParsableFeaturesFlags => {
  return {
    cryptographyVersion: raw.cryptographyVersion,
    poaIsEnabled: raw.poaIsEnabled === "true",
    adsIsEnabled: raw.adsIsEnabled === "true",
    actsRegistryEnabled: raw.actsRegistryEnabled === "true",
    ojrFormationFlowEnabledV1: raw.ojrFormationFlowEnabledV1 === "true",
    supervisionIntegrationSettingsEnabled:
      raw.supervisionIntegrationSettingsEnabled === "true",
  };
};
